export default __webpack_public_path__ + "static/media/m31.d7826d67.png";